import React from 'react';
import { Button } from "@material-ui/core"
import { useStyles } from "../styles";
import CloseIcon from "@material-ui/icons/Close";
import IMenuItemBody from '../../../../../interfaces/IMenuItemBody';
import { Field, FIELD_TYPES } from '../../../../../yoello-lib/modules/components/draggable-list';


export interface ISelectedMenuItemsComponentProps {
    itemData: IMenuItemBody;
    onDelete: (id: string) => void;
    deleteDisabled: boolean;
    fields?: Field<any, any>[]
}


export function SelectedMenuItemsComponent(props: ISelectedMenuItemsComponentProps) {
    const classes = useStyles();

    function renderFields() {
        const renderText = (field: Field<any, any>) => {
            return field.modifier ? field.modifier(props.itemData[field.key], props.itemData) : props.itemData[field.key];
        };

        return props.fields?.map((field) => {
            const style: React.CSSProperties & {
                transformBox?:
                | "inherit"
                | "initial"
                | "-moz-initial"
                | "revert"
                | "unset"
                | "border-box"
                | "fill-box"
                | "view-box"
                | undefined;
            } = {};

            if (props.itemData[field.key]) {
                style.backgroundImage = `url('${props.itemData[field.key]}')`;
            }

            return field.type === FIELD_TYPES.IMAGE ? (
                <div
                    key={field.key}
                    className={`draggable-${field.key}`}
                    style={style}
                ></div>
            ) : (
                <div key={field.key} className={`draggable-${field.key}`}>
                    {renderText(field)}
                </div>
            );
        });
    };
    return (
        <div className={classes.SelectedMenuItemsComponentDiv}>
            {
                props.fields ? renderFields() :
                    <>
                        <div>
                            <p>{props.itemData.name_public}</p>
                            <p>{props.itemData.name_internal}</p>
                        </div>
                        <Button disabled={props.deleteDisabled} onClick={() => props.onDelete(props.itemData.id ?? props.itemData.name_public)}>
                            <CloseIcon />
                        </Button>
                    </>
            }
        </div>
    )
}
